<div class="container p-2" role="alert" [ngClass]="metric | dsMetricStyleConfig">
  <div #container></div>
</div>



